import Icon, { ICONS } from "components/common/Icons";
import { useRouter } from "next/router";
import { useState, useEffect, useMemo, useContext } from "react";
import { handleSDInterest } from "utils/clientAPIs/interest";
import axios from "axios";
import CustomToast from "components/atoms/CustomToast";
import { DetailButtonsContext } from "./Index";
import * as Sentry from "@sentry/nextjs";
import { useDetailInterestClick } from "./DetailHeaderBtnsClick";

function InterestButton() {
  const router = useRouter();
  const {
    handleStarClick,
    interestToastVisible,
    interestErrorToastVisible,
    isInterested,
    setInterestToastVisible,
  } = useDetailInterestClick();

  return (
    <div
      className="p-[6px] cursor-pointer"
      onClick={async () => {
        window.dataLayer.push({
          event: "cDetailInterest",
        });
        await handleStarClick();
      }}
    >
      {isInterested ? (
        <Icon
          name={ICONS.GRADE}
          width={30}
          height={30}
          fill={isInterested ? "blue40" : "gray40"}
        />
      ) : (
        <InterestInactiveIcon />
      )}
      <CustomToast
        message={
          router.locale == "ko"
            ? isInterested
              ? "관심 자산으로 추가됐어요"
              : "관심 자산이 삭제됐어요"
            : isInterested
            ? "Successfully added"
            : "Successfully deleted"
        }
        isVisible={interestToastVisible && !interestErrorToastVisible}
        onClose={() => setInterestToastVisible(false)}
        width={
          isInterested
            ? router.locale === "ko"
              ? 220
              : 205
            : router.locale === "ko"
            ? 205
            : 210
        }
      />
    </div>
  );
}

const InterestInactiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M16.6071 5.97897L18.8621 10.6187L24.1219 11.246C25.5992 11.4222 26.1981 13.1863 25.1175 14.1788L21.2628 17.8387L22.2059 22.9621C22.4699 24.401 20.9001 25.4906 19.5961 24.7735L15.0026 22.2705L10.4091 24.7735C9.10511 25.4906 7.53529 24.401 7.79927 22.9621L8.74239 17.8387L4.88768 14.1788C3.80714 13.1863 4.40598 11.4222 5.88326 11.246L11.1432 10.6187L13.4182 5.97429C14.0557 4.67305 15.9737 4.67587 16.6071 5.97897Z"
        fill="var(--gray30)"
      />
    </svg>
  );
};

export default InterestButton;
